export default "/fonts/iconly.eot?92154df51a4be6e512218abbeff70bf1";